import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ComingSoon.css';
import Navbar from '../Homepage/Navbar/Navbar';
import Footer from '../Homepage/Footer/Footer';

const ComingSoon = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect to homepage after 3 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div id="coming-soon-page">
      <Navbar />
      <div id="coming-soon-container">
        <div id="coming-soon-content">
          <div id="coming-soon-header">
            <h1 id="coming-soon-title">Coming Soon</h1>
          </div>
          
          <div id="coming-soon-footer">
            <div id="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;